<div class="background-container">
  <div class="container-sm">
    <mpro-login-header [title]="'Reset your password'"></mpro-login-header>
    <form *ngIf="!success">
      <input type="login" class="form-control mb-4" placeholder="Enter email address" [formControl]="email">
      <div *ngIf="error" class="error">
        <span>{{ error }}</span>
      </div>
      <button id="big-button" type="submit" (click)="resetPassword()" [class.active]="email.valid" [disabled]="!email.valid">RESET PASSWORD</button>
    </form>
    <span *ngIf="success" class="success">Check your email for instructions on how to reset your password.</span>
  </div>
</div>
